import zh_ui from './zh_ui'
import zh_wp from './zh_wyrmprints'
import zh_ab from './zh_abilities'
import zh_ex from './zh_exclusive'
import en_ui from './en_ui'
import en_wp from './en_wyrmprints'
import en_ab from './en_abilities'
import en_ex from './en_exclusive'
import ja_ui from './ja_ui'
import ja_wp from './ja_wyrmprints'
import ja_ab from './ja_abilities'
import ja_ex from './ja_exclusive'

const messages = {
  zh: Object.assign(zh_ui, zh_wp, zh_ab, zh_ex),
  en: Object.assign(en_ui, en_wp, en_ab, en_ex),
  ja: Object.assign(ja_ui, ja_wp, ja_ab, ja_ex),
}

export function getMessages(locale) {
  locale = locale.trim().toLowerCase()
  if (locale.match(/^zh/))
    return messages.zh
  else if (locale.match(/^ja/))
    return messages.ja
  else
    return messages.en
}